$ = jQuery.noConflict();

function updateList() {
    var value = Math.round(document.getElementById('weight').noUiSlider.get());
    var lowestPrice = null;

    if ($('#categories').length > 0) {
        $('.product').hide();
        $('.category').each(function() {
            if ($(this).attr('data-active') == '1') {
                $('.' + $(this).attr('id')).show();
            }
        });    
    }
    else {
        $('.product').show();
    }

    $('.product').each(function () {
        if (parseInt($(this).attr('data-traffic')) >= value && $(this).is(':visible')) {  
            if (lowestPrice === null) {
                lowestPrice = $(this).attr('data-price');
            } 
        }
        else {
            $(this).hide();
        }
    });

    $('#sek-per-month').html(lowestPrice);

    if (value < 10) {
        value = '<10';
    }
    else if (value > 200) {
        value = '>200';
    }

    $('#traffic').html(value);

    $('#num-broadbands').html($('.product:visible').length);
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return null;
}

$(document).ready(function() {
    var rangeSlider = document.getElementById('weight');

    if (rangeSlider) {
        noUiSlider.create(rangeSlider, {
            start: [ parseInt($('#initial_value').val()) ],
            range: {
                'min': [  parseInt($('#minimum_value').val()) ],
                'max': [ parseInt($('#maximum_value').val()) ]
            },
            step: parseInt($('#step_value').val()),
            connect: 'lower',
    
        });
    
        rangeSlider.noUiSlider.on('slide', function(values, handle){
            var value = Math.round(values[handle]);        
            updateList(value);
        });   
    
        updateList();    
    }

    tippy('.campaign-icon', {

    });

    var cookieConsent = getCookie('cookie-consent');
    if (null === cookieConsent) {
        $('#cookie-consent').fadeIn();
    }

    $('#agree-cookies').click(function() {
        setCookie('cookie-consent', 1, 31);
        $('#cookie-consent').fadeOut();
    });

    $(' .category').each(function() {
        if ($(this).attr('data-active') == "1") {
            $(this).addClass('bg-yellow-300 border-gray-600');
        }
        else {
            $(this).addClass('border-gray-300');
        }

        updateList();
    });

    $('.category').click(function() {
        if ($(this).attr('data-active') == "1") {
            $(this).attr('data-active', '');
            $(this).removeClass('bg-yellow-300 border-gray-600').addClass('border-gray-300');
            
        }
        else {
            $(this).attr('data-active', '1');
            $(this).removeClass('border-gray-300').addClass('bg-yellow-300 border-gray-600');
        }

        updateList();
    });

    $('#sidenav-toggle').click(function() {
        $('#sidenav').removeClass('hidden animate__fadeOutRight').addClass('animate__fadeInRight');
    });

    $('#close-sidenav').click(function() {
        $('#sidenav').removeClass('animate__fadeInRight').addClass('animate__fadeOutRight');
    });

});